import { useMemo } from 'react'
import type { FilterValues } from '../filter-panel/context/filter-context'

export interface TransformedOrderItemFilters {
  'genre-ids'?: number[]
  'network-ids'?: number[]
  'offering-types'?: ('deal' | 'bundle')[]
  'cpm-min'?: number
  'cpm-max'?: number
  'air-dates-start'?: Date
  'air-dates-end'?: Date
}

export const useTransformedOrderItemFilters = (filters: FilterValues): TransformedOrderItemFilters => {
  return useMemo(() => {
    const genreIds = filters.genreIds?.length
      ? filters.genreIds.map((id: string) => Number(id)).filter((id: number) => !Number.isNaN(id))
      : undefined

    const networkIds = filters.networkIds?.length
      ? filters.networkIds.map((id: string) => Number(id)).filter((id: number) => !Number.isNaN(id))
      : undefined

    const offeringTypes = filters.offeringTypes?.length ? filters.offeringTypes : undefined

    const cpmMin = filters.cpmRange?.min
    const cpmMax = filters.cpmRange?.max

    const airDatesStart = filters.airDates?.start
    const airDatesEnd = filters.airDates?.end

    const transformed = {
      'genre-ids': genreIds,
      'network-ids': networkIds,
      'offering-types': offeringTypes,
      'cpm-min': cpmMin,
      'cpm-max': cpmMax,
      'air-dates-start': airDatesStart,
      'air-dates-end': airDatesEnd,
    }

    return Object.fromEntries(
      Object.entries(transformed).filter(([_, value]) => value !== undefined),
      // biome-ignore lint/nursery/noUnsafeTypeAssertion: RETIRED, do not copy. Fix the source type or narrow the value when touching this.
    ) as TransformedOrderItemFilters
  }, [filters])
}
